import React, { useContext } from "react"; 
import MeContext from "../MeContext";
import { LoginPage } from "../p";

export const SafeRoute = ({children}) => {
  const { me } = useContext(MeContext)

  if(!me){
    return <LoginPage />
  }

  return (<>
    {children}
  </>)
}
